// src/components/ProtectedAdminRoute.jsx
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthProvider";
import LoadingSpinner from "../LoadingSpinner";

const ProtectedAdminRoute = ({ children }) => {
  const { isLoading, userData, handleLogin } = useContext(AuthContext);
  const location = useLocation();

  const isAdmin = Boolean(
    userData?.userRoles?.includes("authenticated") &&
      userData?.userRoles?.includes("admin")
  );

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      const target = location.pathname + location.search;
      try {
        localStorage.setItem("postLoginRedirect", target);
      } catch (e) {}
      handleLogin(target);
    }
  }, [isLoading, isAdmin, handleLogin, location]);

  if (isLoading) return <LoadingSpinner />;
  if (isAdmin) return children;
  return null;
};

export default ProtectedAdminRoute;
